import { IExportData } from "@/pages/export-list/types";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { dateFormatter, FormatType } from "project-config/utils/date-formatter";
import { ColumnType } from "antd/es/table/interface";
import { Tooltip } from "@renderbus/ui";
import { Space } from "task-eva-ui";

export const getTableColumns: () => ColumnType<IExportData>[] = () => {
  const t = getTranslateNsT("consumption");
  const centerT = getTranslateNsT("center");
  return [
    {
      title: t("consumption_desktop_id"),
      dataIndex: "desktopIds",
      ellipsis: true,
      render: (v) => {
        const text = Array.isArray(v) ? v.filter(Boolean).join() : v;
        return (
          <Space width="100px">
            <Tooltip
              title={text}
              color={"#202124"}
              tooltipText={<div style={{ maxWidth: "100px" }}>{text}</div>}
              getPopupContainer={() => document.body}
            />
          </Space>
        );
      },
    },
    {
      title: t("consumption_time_selector"),
      dataIndex: "feeTime",
      render: (v) => dateFormatter(v, FormatType.YMD),
    },
    {
      dataIndex: "userName",
      title: t("user_operate_record_user_name"),
    },
    {
      title: t("consumption_table_header_company"),
      key: "company",
      ellipsis: true,
      render: (v) => <ContentWithToolTip content={v.company} />,
    },
    {
      dataIndex: "platformName",
      title: t("user_consume_pick_platform"),
    },
    {
      title: t("consumption_label_fee_type"),
      dataIndex: "feeType",
      render: (row) => t(`consumption_fee_type_${row}`),
    },
    {
      dataIndex: "feeHour",
      title: t("consumption_render_duration_hour"),
      render: (v) => v + centerT(`hours`),
    },
    {
      dataIndex: "nodeType",
      title: t("consumption_desktop_machine_type"),
      render: (v) => ["CPU", "GPU"][v] || "",
    },
    {
      dataIndex: "nodeNum",
      title: t("consumption_desktop_machine_count"),
    },
    {
      dataIndex: "feeAmount",
      title: t("consumption_desktop_consume"),
    },
  ];
};

export function ContentWithToolTip({
  maxWidth = 220,
  fontSize = 14,
  content,
}: {
  maxWidth?: number;
  fontSize?: number;
  content: string | number;
}) {
  if (String(content).length * fontSize > maxWidth) {
    return (
      <Tooltip
        placement="top"
        title={content}
        color={"#202124"}
        triggerBody={document.body}
        tooltipText={<div style={{ maxWidth: `${maxWidth}px` }}>{content}</div>}
      />
    );
  }
  return <span>{content}</span>;
}
